module.exports = __webpack_public_path__ + "assets/img/ic-reply.693f4d24.svg";